import RealTimeActions from './realtime-actions';
import { RootScopeEvents } from 'common/services/root-scope-types';
import { VideoChatRealtimeMessageTypes } from '../../video-chat/video-chat.realtime-component';
export default class DoctorRealTimeActions extends RealTimeActions {
    /* @ngInject */
    constructor(pn, $timeout, activeComponents, $log, globalUi, communicationControl, downgradeCallStateService, closedCaptionsService, $injector) {
        super(activeComponents, $log, pn, $timeout);
        this.activeComponents = activeComponents;
        this.$log = $log;
        this.globalUi = globalUi;
        this.communicationControl = communicationControl;
        this.downgradeCallStateService = downgradeCallStateService;
        this.closedCaptionsService = closedCaptionsService;
        this.extensionsPathMap = {
            payment: './payment/doctor.js',
            server: './server/doctor.js',
            screenshare: './screensharing/doctor.js',
        };
        this.onLeaveComponentNames = [
            'chat',
            'payment',
            'screenshare',
            'fileTransfer',
            'teleconsent',
        ];
        this.$rootScope = $injector.get('$rootScope');
    }
    onMessage(data, person) {
        const { componentName, action, content } = data.message;
        this.$log.debug(`mediator:message:${componentName}:${action}`, data, person);
        if (action === 'transferSuccessful') {
            this.$rootScope.$emit(RootScopeEvents.PATIENT_TRANSFER.COMPLETED, {
                transfer_id: content.senderNotifyKey,
            });
        }
        switch (`message:${componentName}:${action}`) {
            case 'message:phone:end': {
                this.onPhoneEnd();
                break;
            }
            case 'message:phone:restart': {
                this.onPhoneRestart();
                break;
            }
            case `message:phone:${VideoChatRealtimeMessageTypes.CAPTIONS_TOGGLE}`: {
                this.onCaptionsToggle(data.message, person);
                break;
            }
            case 'message:phone:downgradeToAudio': {
                this.onDowngradeToAudio();
                break;
            }
            case 'message:phone:connectionImproved': {
                this.onConnectionImprove();
                break;
            }
            default: {
                this.onExtension(data.message, person);
                break;
            }
        }
    }
    onPhoneRestart() {
        this.activeComponents.phone.isRestartingCall = true;
        this.communicationControl.phoneStop();
        this.globalUi.startCall();
    }
    onPhoneEnd() {
        this.communicationControl.phoneStop();
    }
    onDowngradeToAudio() {
        this.downgradeCallStateService.downgradeToAudioOnly({
            currentPersonIsCulprit: true,
        });
    }
    onConnectionImprove() {
        this.downgradeCallStateService.connectionImproved();
    }
    onCaptionsToggle(message, person) {
        this.closedCaptionsService.onCaptionsToggle(message, person);
    }
}
